<template>
    <div>
        <div style="" class="leftTitle mt-3 clearfix ">
            <!--Vzdelanie-->
            <li><span class="education"></span>{{$t("education.1")}}:</li>
        </div>
        <div style="" class="mt-1 clearfix">
            <!---->
            <div class="otherInfoLeft  "><span class="USYears"></span>2013-2017:</div>
            <!--Uplné stredné-->
            <div class="otherInfoLeft bold "><span class="US"></span>{{$t("education.2")}}</div>
        </div>
        <div style="" class="mt-1 clearfix">
            <!--Maturita-->
            <div class="otherInfoLeft  "><span class="maturity"></span>{{$t("education.3")}}:</div>
            <!--CNC stroje-->
            <div class="otherInfoLeft bold "><span class="CNC">{{$t("education.4")}}</span></div>
        </div>
        <div style="" class="mt-1 clearfix">
            <div class="otherInfoLeft  "><span class="basicYears"></span>1976-1983:</div>
            <!--Základné-->
            <div class="otherInfoLeft bold "><span class="basic">{{$t("education.5")}}</span></div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>